import React from 'react';
import { translate } from 'react-i18next';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle } from '../../utils/utils';
import {
  styles, selectStyle, inputLabelStyle, optionStyle,
} from './notificationSettingsStyles';

// Pääkäyttäjä picks whose settings to edit. Hidden when the list only holds
// the user themselves.
const NotificationUserPicker = ({
  t, users, selectedUserId, onChange,
}) => {
  if (!users || users.length < 2) {
    return null;
  }
  const optionLabel = (user) => {
    if (user.is_self) {
      return t('ownSettingsOption');
    }
    const name = user.name && user.name !== user.email ? `${user.name} (${user.email})` : user.email;
    return user.entities && user.entities.length ? `${name} – ${user.entities.join(', ')}` : name;
  };
  return (
    <CBMediaQuery>
      {screenSize => (
        <div style={getStyle(screenSize, styles, 'card')}>
          <label htmlFor='notification-user-picker' style={inputLabelStyle}>{t('userPickerLabel')}</label>
          <select
            id='notification-user-picker'
            data-testid='notification-user-picker'
            style={selectStyle}
            value={selectedUserId || ''}
            onChange={event => onChange(event.target.value ? parseInt(event.target.value, 10) : null)}
          >
            {users.map(user => (
              <option key={user.id} style={optionStyle} value={user.is_self ? '' : user.id}>{optionLabel(user)}</option>
            ))}
          </select>
        </div>
      )}
    </CBMediaQuery>
  );
};

export default translate('NotificationSettings')(NotificationUserPicker);
